import { date } from './date';
import { kind } from './kind';
import { eventType } from './eventType';
import { message } from './message';
import { name } from './name';

export const columns = [date, name, kind, eventType, message];
